import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';
import DashboardCards from '../components/widget/DashboardCards';

import * as Constants from '../store/index';
import Filter from '../components/widget/Filter';
import Card from '../components/widget/Card';
import Button from '../components/html/Button';
import ChartRequest from '../components/widget/ChartRequest';

import axios from "axios";
import { useStatistics } from '../hooks/useStatistics';

function ChatConfig(props) {

  
  const [isChat, setIsChat] = useState(false);
  const [isAutoReply, setIsAutoReply] = useState(false);
  const [loading, setLoading] = useState(false);

  const setChat = (store) =>{
    const {moduleConfig} = store;
    let isSet = false;
    if(moduleConfig){
      for (let i = 0; i < moduleConfig.length; i++) {
        if (moduleConfig[i].name == "CHATBOT") {
          setIsChat(moduleConfig[i].active);
          isSet = true;
        }else
        if (moduleConfig[i].name == "AUTO_REPLY") {
          setIsAutoReply(moduleConfig[i].active);
        }
      }
    }
    if(!isSet){
      setIsChat(null);
    }
    if(!isSet && window.location.href.indexOf("chatbot") > -1){
      setIsChat(false);
    }
  }
  
  const [accountReturnPhone, setAccountReturnPhone] = useState("");
  
  let startDate = new Date();
  let endDate = new Date();
  startDate.setDate(endDate.getDate() - 60);
  

  useEffect(() => {
    const store = Util.getAdminShop();
    setChat(store);
    if(store.plan.planType === "PLUS"){
      getAccount();
    }
  }, []);

  const getAccount = () =>{
    setLoading(true);
    let shop =  Util.getAdminShop();
    let newWA = {};
    if(shop && shop.marketingCredential){
      newWA.marketingCredential = shop.marketingCredential;
    }
    const url = window.url_server_2+"facebook/subaccount/?shop="+Util.getShopDomain();
    newWA["accessTokenStore"] = Constants.getAccessTokenStore();
    axios.post(url, newWA, {}).then(response => response.data,error => {
        return error;
      }).then((data) => {
        if (data && data.code === "200"){
          console.log(data);
          let account = JSON.parse(data.data);
          if(account.phone && account.phone !== "" ){
            setAccountReturnPhone(account.phone);
          }
        }else{
          alert("Ocurrio un error al obtener la cuenta, comuniquese con Revie!");
        }
        setLoading(false);
    });
  }


  const save = (value, type="CHATBOT") => {
    setLoading(true);
    let shop = Util.getAdminShop();
    let {moduleConfig} = shop;
    let isSet = false;
    let isSetInbox  = false;
    if(moduleConfig){
      for (let i = 0; i < moduleConfig.length; i++) {
        if (moduleConfig[i].name == type) {
          moduleConfig[i].active = value;
          isSet = true;
        }
      }
    }
    
    if(!isSet){
      moduleConfig.push({name: type, active: value});
    }
    shop.moduleConfig = moduleConfig;
    Util.setInfoShop(handleOkShop, handleOkShoperror, shop);
  }

  const handleOkShoperror = (data) => {
      console.log(data);
  }

  const handleOkShop = (data) => {
    if (data && data.id){
        localStorage.setItem(Constants.storage.USER_SHOP, JSON.stringify(data));
        setChat(data);
    }
    setLoading(false);
  }

  const active = () =>{
    save(true);
  }

  const inactive = () => {
    save(false);
  }
  const setDataUrl = (data) => {
    alert("Acción realizada con éxito!");
  }

  const inyectButton = (action, position) =>{
    if(accountReturnPhone && accountReturnPhone !== ""){
      Util.themeButtonWhatsapp(accountReturnPhone, action, position, setDataUrl, (data) => {});
    }else{
      let shop = Util.getAdminShop();
      let {id} = shop;
      if(id === "60770517158"){//richline
        Util.themeButtonWhatsapp("15206557686", action, position, setDataUrl, (data) => {});
      }
    }
  }


 
  return (
    <div className='home'>
          <>
            <h1 style={{margin: "1rem 0rem 2rem 0rem"}}>Configuración</h1>
            <div className='contect-chatbot-check' >
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="Ilustración Lia" />
                <div className='text-chatbox'>
                  <label className='title-chat'>{Util.getMessage(isAutoReply ? "chatbothelp30" : "chatbothelp31")}</label>
                  <small>{Util.getMessage(isAutoReply ? "chatbothelp32" : "chatbothelp33")}</small>
                  {isAutoReply ? (
                    <Button disabled={loading || isChat} value={Util.getMessage("button_disable")} type="primary" onClick={() => save(false, "AUTO_REPLY")}/>
                  ) : (
                    <Button disabled={loading || isChat} value={Util.getMessage("button_active")} type="primary" onClick={() => save(true, "AUTO_REPLY")}/>
                  )}
                </div>
            </div>
            <div className='contect-chatbot-check' >
                <img src="img/ia/lia.png" alt="Ilustración Lia" />
                <div className='text-chatbox'>
                  <label className='title-chat'>{Util.getMessage(isChat ? "chatbothelp1" : "chatbothelp26")}</label>
                  <small>{Util.getMessage(isChat ? "chatbothelp2" : "chatbothelp27")}</small>
                  {isChat ? (
                    <Button disabled={loading} value={Util.getMessage("button_disable")} type="primary" onClick={() => inactive()}/>
                  ) : (
                    <Button disabled={loading} value={Util.getMessage("button_active")} type="primary" onClick={() => active()}/>
                  )}
                </div>
            </div>   
            {Util.isShopify(Util.getAdminShop()) && (
              <div className='contect-chatbot-check' >
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="Ilustración Lia" />
                  <div className='text-chatbox'>
                    <label className='title-chat'>{Util.getMessage("chatbothelp3")}</label>
                    <small>{Util.getMessage("chatbothelp4")}</small>
                    <div className='button-whatsapp'>
                      <div>
                        <h2>Activar el botón de WhatsApp en la tienda</h2>
                        <div style={{display: "flex",gap: "1rem",marginTop: "1rem"}}>
                          <Button disabled={loading || !isChat} value={Util.getMessage("chatbothelp5")} type="primary" onClick={() => inyectButton("add", "left")}/>
                          <Button disabled={loading || !isChat} value={Util.getMessage("chatbothelp6")} type="primary" onClick={() => inyectButton("add", "right")}/>
                        </div>
                      </div>
                      <div>
                        <h2>Desactivar el botón de WhatsApp en la tienda</h2>
                        <div style={{display: "flex",gap: "1rem",marginTop: "1rem"}}></div>
                          <Button disabled={loading} value={Util.getMessage("chatbothelp7")}  onClick={() => inyectButton("remove", "right")}/>
                        </div>
                      </div>
                    </div>
              </div> 
            )}
              
          </>
        

        
      <div>

      </div>
    </div>
  );
}

export default ChatConfig;